/**
 * Test IDs for QA automation.
 */
export const testIds = {
  mileageInputMiles: "mileage-input-miles",
} as const;
